/**
 * Portfolio domain schema (partial), derived from the generated Zod. Scoped to
 * the `useDocumentUpload` picker, which reads only `id`/`name`.
 *
 * ⚠️ For whoever converts the full portfolio domain: `client` arrives null for
 * a portfolio with no client group, but the generated base types it required.
 */
import type { z } from 'zod';

import { PortfoliosListResponse } from '~/data/generated/zod/portfolios/portfolios.zod';

export const portfolioOptionSchema = PortfoliosListResponse.element.pick({
  id: true,
  name: true,
});

type PortfolioOption = z.infer<typeof portfolioOptionSchema>;

/**
 * The trimmed `{id, name}` portfolio dict embedded on other reads (invoice,
 * ticket). Structurally the picker row, so it shares the same schema.
 */
export type Portfolio = PortfolioOption;
